// Only included on production environments
require('core-js/features/promise')
require('core-js/features/array/iterator')
require('regenerator-runtime/runtime')

export const environmentImports = [
    import('../lib/bootstrap/polyfills'/* webpackChunkName: "polyfills" */),
    import('../lib/bootstrap/browserUpdate'/* webpackChunkName: "browser-update" */),
    import('../lib/bootstrap/awin'/* webpackChunkName: "awin" */),
    import('../lib/bootstrap/travelagency'/* webpackChunkName: "travelagency" */)
]
